import { render, staticRenderFns } from "./ComplexTables.vue?vue&type=template&id=6ba163f4&"
import script from "./ComplexTables.vue?vue&type=script&lang=js&"
export * from "./ComplexTables.vue?vue&type=script&lang=js&"
import style0 from "./ComplexTables.vue?vue&type=style&index=0&id=6ba163f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports